import { render } from "./TimelineSection.vue?vue&type=template&id=08c4baed&scoped=true"
import script from "./TimelineSection.vue?vue&type=script&lang=js"
export * from "./TimelineSection.vue?vue&type=script&lang=js"

import "./TimelineSection.vue?vue&type=style&index=0&id=08c4baed&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-08c4baed"]])

export default __exports__